import { render, staticRenderFns } from "./BackgroundLoader.vue?vue&type=template&id=0df28e42&"
import script from "./BackgroundLoader.vue?vue&type=script&lang=js&"
export * from "./BackgroundLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports